import { API_BASE_URL } from "../utils/environment";
import Api from "./Api";

const api = new Api(API_BASE_URL);

export default api;
